import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three";
import earthMap from "../images/earthmap.jpg";
import earthMapOceans from "../images/earthmapOceans.jpg";


const Globe = ({ points }) => {
    const globeRef = useRef();

    // Rotate globe slowly
    useFrame(() => {
        if (globeRef.current) {
            globeRef.current.rotation.y += 0.0025;
        }
    });

    const globeTexture = new THREE.TextureLoader().load(earthMap);
    const oceanTexture = new THREE.TextureLoader().load(earthMapOceans);

    globeTexture.colorSpace = THREE.SRGBColorSpace;
    oceanTexture.colorSpace = THREE.SRGBColorSpace;
    const sphereGeometrySize = 6

    return (
        <group ref={globeRef} rotation={[0.7, -1.2, 0]}>
            {/* Ocean layer (base) */}
            <mesh renderOrder={0}>
                <sphereGeometry args={[sphereGeometrySize, 64, 64]} />
                <mesh renderOrder={0}>
                <sphereGeometry args={[sphereGeometrySize, 64, 64]} />
                <meshStandardMaterial
                    map={oceanTexture}
                    roughness={0.6}       
                    metalness={0}
                    emissive={new THREE.Color(0x000000)}
                    emissiveIntensity={0}
                    depthWrite={true}
                />
                </mesh>
            </mesh>

            {/* Land layer (slightly above) */}
            <mesh renderOrder={1}>
                <sphereGeometry args={[sphereGeometrySize, 64, 64]} />
                <meshStandardMaterial
                    map={globeTexture}
                    transparent={true}
                    opacity={0.85}
                    depthWrite={false}
                />
            </mesh>

            {/* Blip points */}
            {points.map((point, i) => {
                const { lat, lon } = point;
                const phi = (90 - lat) * (Math.PI / 180);
                const theta = (lon + 180) * (Math.PI / 180);
                const radius = 2;

                const x = radius * Math.sin(phi) * Math.cos(theta);
                const y = radius * Math.cos(phi);
                const z = radius * Math.sin(phi) * Math.sin(theta);

                return (
                    <mesh key={i} position={[x, y, z]}>
                        <sphereGeometry args={[0.06, 8, 8]} />
                        <meshStandardMaterial
                            //   color="white"
                            emissive="red"
                            emissiveIntensity={1.2}
                        />
                    </mesh>
                );
            })}
        </group>
    );
};

export const GlobeHero = () => {
    const points = [
        { lat: 37.77, lon: -122.42 },
        { lat: 51.51, lon: -0.12 },
        { lat: 35.68, lon: 139.69 },
    ];

    return (
        <div className="globe-wrapper">
            <Canvas
                camera={{ position: [0, 0, 10] }}
                style={{ background: "transparent" }}
                gl={{ outputColorSpace: THREE.SRGBColorSpace }}
            >
                <ambientLight intensity={1.0} />
                <directionalLight position={[5, 5, 5]} intensity={0.8} />
                <hemisphereLight skyColor={0xffffff} groundColor={0x444444} intensity={0.6} />
                <Globe points={points} />
                <OrbitControls enableZoom={false} enablePan={false} enableRotate={false} />
            </Canvas>
        </div>
    );
};